export class Config {
    static isLogEnabled = false;
    static isRuningInWorker = false;
}